module.exports = __webpack_public_path__ + "img/w3_circle_bars_dark.21dd24fb.png";